<template>
    <div class="m-formula__container">

        <!--<control :label="'Dependency Type'" for="method" v-bind:icon-space="false">-->
        <!--<select id="method" v-model="innerMultiplicand.method" @change="updateMultiplicand">-->
        <!--<option value="multiplicand_default">Default</option>-->
        <!--<option value="multiplicand_percentage">Enter own % dependency</option>-->
        <!--<option value="multiplicand_pounds">Enter own dependency in £</option>-->
        <!--</select>-->
        <!--</control>-->

        <control label="Enter percentage" for="own_total_figure" before-after="percent"
                 v-if="innerMultiplicand.method==='multiplicand_percentage'">
            <input autocomplete="off" type="number" v-model="innerMultiplicand.percentage" max="100" min="1" @input="updateMultiplicand">
        </control>

        <div class="flex-grid m-formula"
             v-if="innerMultiplicand.method==='multiplicand_percentage' ||
                innerMultiplicand.method==='multiplicand_default'">
            <div class="flex-grid m-formula__item--row">
                <b>Dependency Formula</b>
            </div>
            <div class="flex-grid m-formula__item--row">
                <p v-if="!hasMultipleDependants && innerMultiplicand.method === 'multiplicand_default'">2/3 x [ </p>
                <p v-if="hasMultipleDependants && innerMultiplicand.method === 'multiplicand_default'">75% x [ </p>
                <p v-if="innerMultiplicand.method === 'multiplicand_percentage'">
                    <input autocomplete="off" :value="innerMultiplicand.percentage" class="a-form-inputs--readonly" disabled type="text">% x [
                </p>
                <div class="a-form-inputs--pound">
                    <input autocomplete="off" :value="theDeceasedNetIncome" class="a-form-inputs--readonly" disabled type="text">
                </div>
                <p>+</p>
                <div class="a-form-inputs--pound">
                    <input autocomplete="off" :value="dependantsNetIncome" class="a-form-inputs--readonly" disabled type="text">
                </div>
                <p>] -</p>
                <div class="a-form-inputs--pound">
                    <input autocomplete="off" :value="dependantsNetIncome" class="a-form-inputs--readonly" disabled type="text">
                </div>
            </div>
            <div class="flex-grid m-formula__item--row">
                <p>Total =</p>
                <div class="a-form-inputs--pound">
                    <input autocomplete="off" class="a-form-inputs--readonly" disabled :value="innerMultiplicand.total" type="text">
                </div>
            </div>
        </div>
        <control label="Enter own dependency in £" for="own_total_figure" before-after="pound"
                 v-if="innerMultiplicand.method==='multiplicand_pounds'">
            <input autocomplete="off" type="number" v-model="innerMultiplicand.user" @input="updateMultiplicand">
        </control>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import control from 'components/form/Control.vue';
    export default {
        name: 'multiplicand',
        computed: {
            ...mapGetters('fatal/dependency/dependants', {
                dependantsNetIncome: 'dependantNetIncome',
                dependantGrossIncome: 'dependantGrossIncome',
                hasMultipleDependants: 'hasMultipleDependants',
            }),
            ...mapGetters('fatal/dependency/deceased', {
                theDeceasedNetIncome: 'theDeceasedNetIncome',
                theDeceasedGrossIncome: 'theDeceasedGrossIncome',
                theDeceased: 'theDeceased'
            }),
            ...mapGetters('fatal/dependency/multiplicand', {
                theMultiplicand: 'theMultiplicand'
            }),
            innerMultiplicand() {
                return _.cloneDeep(this.theMultiplicand);
            }
        },
        components: {control},
        watch: {
            // If any of the these values change, update
            ['innerMultiplicand.percentage']()  {
                this.updateMultiplicand();
            }
        },
        methods: {
            ...mapActions('fatal/dependency/multiplicand', {
                adjustTheMultiplicand: 'adjustTheMultiplicand',
            }),
            updateMultiplicand() {
                if (this.innerMultiplicand.method === 'multiplicand_default') {
                    this.innerMultiplicand.percentage = '';
                    this.innerMultiplicand.user = '';
                }
                this.adjustTheMultiplicand(this.innerMultiplicand);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Mutiplicand.vue?548e9b32